import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { SaveStatus } from '../../enums/SaveStatus';

import '../../styles/App.css';

type SaveButtonProps = {
    saveStatus: SaveStatus,
    onClick?: () => void | undefined,
    saveText?: string,
    savingText?: string,
    savedText?: string,
    errorText?: string,
};

const SaveButton = ({ saveStatus, onClick, saveText = 'Save', savedText = 'Saved', savingText = 'Saving', errorText = 'Failed' }: SaveButtonProps) => {
    const [saving, setSaving] = useState<boolean>(false);

    useEffect(() => {
        if (saveStatus !== SaveStatus.Saving) {
            setSaving(false);
        }
    }, [saveStatus]);

    const getButtonString = (status: SaveStatus) => {
        switch(status) {
            case SaveStatus.Unsaved:
                return saveText;

            case SaveStatus.Saving:
                return savingText;

            case SaveStatus.Saved:
                return savedText;

            case SaveStatus.Error:
                return errorText;
        }
    };

    const getButtonColoring = (status: SaveStatus) => {
        switch(status) {
            case SaveStatus.Unsaved:
                return 'btn-primary';

            case SaveStatus.Saving:
                return 'btn-outline-primary';

            case SaveStatus.Saved:
                return 'btn-outline-success';

            case SaveStatus.Error:
                return 'btn-outline-danger';
        }
    };

    const handleOnClick = () => {
        if (saveStatus === SaveStatus.Saved) {
            return;
        }
        if (saveStatus === SaveStatus.Saving) {
            return
        }
        setSaving(true);
        if(onClick) {
            onClick();
        }
    };

    return (
        <button
            type='button'
            className={`btn data-source-btn ${getButtonColoring(saveStatus)}`}
            onClick={handleOnClick}
        >
        {saving && <Spinner animation='border' size='sm' role='status' aria-hidden='true' />}
        {!saving && (getButtonString(saveStatus))}
        </button>
    );
}

export default SaveButton;